







































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  relationStudentDetailApi,
  studentCourseLogListApi,
} from "@/api/teacherManage";
import { dateFormat } from "@/utils/timeFormat";
@Component({
  components: {},
})
export default class extends Vue {
  @Prop() rid!: number;
  @Prop() studentId?: number;
  @Prop() courseId?: number;
  dialogTableVisible = false;
  num: number = 3;
  detailInfo = [];
  showDialog() {
    this.dialogTableVisible = true;
  }
  openDialog() {
    if (this.rid) {
      relationStudentDetailApi({
        relation_id: this.rid,
      }).then((res: any) => {
        if (res.error_code === 0) {
          res.data.list.map((item: any) => {
            item.create_time = this.getTime(
              new Date(Number(item.create_time + "000"))
            );
          });
          this.detailInfo = res.data.list;
        }
      });
    } else if (this.studentId && this.courseId) {
      studentCourseLogListApi({
        student_id: this.studentId,
        course_id: this.courseId,
      }).then((res) => {
        res.data.list.map((item: any) => {
          item.create_time = this.getTime(
            new Date(Number(item.create_time + "000"))
          );
        });
        this.detailInfo = res.data.list;
      });
    }
  }
  getTime(e: any) {
    const format = dateFormat("YYYY-mm-dd", e);
    return format.slice(0, 10);
  }
}
